import React from "react";
import "../css/Popup-Testimoni.css";

const data = [
  {
    id: 1,
    name: "Karimashita Hadini, S.Ikom",
    about: "Narasumber Fammi, Fulltime Home Educator and Partime MC & Speaker",
    imgUrl: "https://i.ibb.co/3fyS1Vb/Mask-Group-1.png",
    testimoni:
      "Mengilhami kebaikan yang Allah berikan melalui pandemi salah satu nya adalah dengan mendekatkan diri dengan ilmu. Keterbatasan gerak, membuat kita berinovasi untuk banyak belajar melalui teknologi. <br/> <br/>Bagi saya, bisa terus belajar dan berbagi ilmu melampaui jarak dan waktu adalah suatu berkah Allah yg luarbiasa. Fammi sangat paham bagaimana cara untuk menghadirkan kemudahan mencari dan mengalirkan ilmu dalam satu wadah yang lengkap. <br/><br/>Saya bangga menjadi bagian dari fammi. Semoga Fammi akan terus mampu mengalirkan banyak kebaikan bagi keluarga indonesia dimanapun berada.",
  },
  {
    id: 2,
    name: "Aisya Yuhanida Noor, M.Psi",
    about: "Narasumber Fammi, Psikolog, Professional Coach dan Penulis Buku",
    imgUrl: "https://i.ibb.co/sqfZfnx/Mask-Group-2.png",
    testimoni:
      "Sebagai orang tua kita tahu kalau menyengaja belajar dan meluangkan waktu untuk belajar itu wajib. Namun pada prakteknya, menemukan kesesuaian waktu belajar dengan jadwal kelas yang ada, dan menemukan materi serta metode belajar yang cocok bukan perkara mudah. <br/><br/>Fammi original series menawarkan solusi atas persoalan ini. Orang tua bisa memilih kelas yang paling dibutuhkan (materi dan pemateri) dan menyesuaikan jadwal belajarnya masing-masing. <br/><br/>  Kapanpun merasa perlu, pengulangan bisa dilakukan sesuai kecepatan dan keluangan waktu belajar masing-masing. Alhamdulillah, tidak ada lagi kendala untuk bisa terus belajar dan mengupgrade diri.",
  },
  {
    id: 3,
    name: "Nilam Qisthia",
    about: "Orangtua Pembelajar di Fammi",
    imgUrl: "https://i.ibb.co/dgdyJ86/image-13.png",
    testimoni:
      "Sangat membantu untuk para bunda mendapatkan gambaran serta langkah langkah untuk memahami emosi anak sehingga ketika anak sedang merasakan emosi negatif, justru dapat memperkuat hubungan ibu dan anak semakin baik",
  },
  {
    id: 4,
    name: "Reisha Ranty",
    about: "Orangtua Pembelajar di Fammi",
    imgUrl: "https://i.ibb.co/S3XDyPT/Mask-Group-3.png",
    testimoni:
      "Baru ini nemu aplikasi yang menyediakan kelas kelas online Ilmu Parenting yang temanya sesuai dan sangat bagus Aplikasi sederhana tapi user friendly, Keren!",
  },
  {
    id: 5,
    name: "Rani Nurhayati",
    about: "Orangtua Pembelajar di Fammi",
    imgUrl: "  https://i.ibb.co/z7qMc6W/Mask-Group-4.png",
    testimoni:
      "Aplikasi yg sangat bermanfaat. Saya sangat senang dgn aplikasi ini, dengan open kelas bisa di akses kapanpun dan bisa d akses selamanya dapat memudahkan saya dalam belajar dgn narasumber yg bagus2. Terimakasih fammi 😍",
  },
];

function PopupTestimoni({ clicks, id }) {
  const filterData = data?.filter((items) => items?.id === id);
  return (
    <>
      <React.Fragment>
        <div className="parent-dialog-tes">
          <div className="box-dialog-tes">
            <div className="section-header-dialog-tes">
              <div
                style={{
                  background: `url(${filterData[0].imgUrl}) center no-repeat`,
                  height: 58,
                  width: 58,
                  borderRadius: 50,
                  backgroundSize: "cover",
                }}
              />
              <div className="section-titles-tes">
                <p className="text-name-dialog-tes">{filterData[0].name}</p>
                <p className="text-about-dialog-tes">{filterData[0].about}</p>
              </div>
            </div>
            <div className="section-content-testimoni">
              <p className="text-content-dialog-tes">
                <div
                  dangerouslySetInnerHTML={{
                    __html: filterData[0].testimoni || "-",
                  }}
                />
              </p>
            </div>
            <button onClick={clicks} className="btn-dialog-tes">
              Tutup
            </button>
          </div>
        </div>
      </React.Fragment>
    </>
  );
}
export default PopupTestimoni;
